export default __webpack_public_path__ + "static/LPHowToStartImage3-037a9b3465753a531d02521ff0406640.jpg";